import { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import "./Login.css";
import { auth } from "../firebase/config";

function Login() {
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerPassword, setRegisterPassword] = useState("");
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");

  const [user, setUser] = useState({});

  onAuthStateChanged(auth, (currentUser) => {
    setUser(currentUser);
  });

  const register = async () => {
    try {
      const user = await createUserWithEmailAndPassword(
        auth,
        registerEmail,
        registerPassword
      );
      console.log(user);
      alert("Signed Up Successfully");
    } catch (error) {
      alert(error.message);
    }
  };

  const login = async () => {
    try {
      const user = await signInWithEmailAndPassword(
        auth,
        loginEmail,
        loginPassword
      );
      console.log(user);
      alert("Signed In Successfully");
    } catch (error) {
      alert(error.message);
    }
  };

  const logout = async () => {
    await signOut(auth);
    alert("Logged out Successfully");
  };

  return (
    <div>
      <Navbar />
      <div className="login-form">
        <div className="user-detail">
          <h4> User Logged In: </h4>
          <h4>{user?.email} </h4>
        </div>
        <div className="logout">
          <button className="btn2" onClick={logout}>
            {" "}
            Sign Out{" "}
          </button>
        </div>

        <div className="sign-up">
          <h3> Register User </h3>
          <div className="row">
            <input
              type="email"
              placeholder="Enter Email"
              onChange={(event) => {
                setRegisterEmail(event.target.value);
              }}
            />
          </div>

          <div className="row">
            <input
              type="password"
              placeholder="Enter Password"
              onChange={(event) => {
                setRegisterPassword(event.target.value);
              }}
            />
          </div>

          <button className="btn1" onClick={register}>
            {" "}
            Create User
          </button>
        </div>

        <div className="sign-in">
          <h3> Login </h3>
          <div className="row">
            <input
              type="email"
              placeholder="Enter Email"
              onChange={(event) => {
                setLoginEmail(event.target.value);
              }}
            />
          </div>

          <div className="row">
            <input
              type="password"
              placeholder="Enter Password"
              onChange={(event) => {
                setLoginPassword(event.target.value);
              }}
            />
          </div>

          <button className="btn1" onClick={login}>
            {" "}
            Login
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Login;
